import * as Sentry from '@sentry/react'
import { SentryFilterTagOneClickYearlyExtension } from '@repo/sentry-utils/constants'

import type { OneClickYearlyExtensionButtonProps } from './components/one-click-yearly-extension-button'
import { OneClickYearlyExtensionButtonComponent } from './components/one-click-yearly-extension-button'

export function OneClickExtensionButton({ ...props }: OneClickYearlyExtensionButtonProps) {
  return (
    <Sentry.ErrorBoundary
      beforeCapture={scope => {
        scope.setTag('component', SentryFilterTagOneClickYearlyExtension)
      }}
    >
      <OneClickYearlyExtensionButtonComponent {...props} />
    </Sentry.ErrorBoundary>
  )
}
